function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "i");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Complete"
}, React.createElement("g", {
  id: "Square"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 2,
  y: 2,
  width: 20,
  height: 20,
  rx: 2,
  ry: 2,
  fill: "none",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));

var SvgSquare = function SvgSquare(props) {
  return React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/square.9e016c27.svg";
export { SvgSquare as ReactComponent };